import React from "react";

const SalesData = () => {
  return (
    <div>
      <div className="chart-box bg-white">
        <div className="d-flex justify-content-between align-items-center">
          <h3>Sales volume data</h3>
          <div className="right-side d-flex align-items-center">
            <span className="full-screen">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2.85714 12.8571H0V20H7.14286V17.1429H2.85714V12.8571ZM0 7.14286H2.85714V2.85714H7.14286V0H0V7.14286ZM17.1429 17.1429H12.8571V20H20V12.8571H17.1429V17.1429ZM12.8571 0V2.85714H17.1429V7.14286H20V0H12.8571Z"
                  fill="#4A4A4A"
                />
              </svg>
            </span>
            <div className="select-bar ml-4">
              <select className="form-control">
                <option value="">All Time</option>
                <option value="">6 hour</option>
                <option value="">12 hour</option>
                <option value="">24 hour</option>
              </select>
            </div>
            <div className="select-bar ml-4">
              <select className="form-control">
                <option value="">Download</option>
                <option value="">Download</option>
                <option value="">Download</option>
                <option value="">Download</option>
              </select>
            </div>
          </div>
        </div>
        <div className="main-chart">
          <img className="img-fluid" src="/img/sales-data.png" alt="" />
        </div>
      </div>
      <div className="chart-box bg-white self-mt">
        <div className="site-table">
          <table className="table darkhead">
            <thead>
              <tr>
                <th>Month</th>
                <th>Sales (USD)</th>
                <th>Market Cap</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="data-highlight">October 2021</td>
                <td>$44,550,080.00</td>
                <td>$7,971,415.50</td>
              </tr>
              <tr>
                <td className="data-highlight">November 2021</td>
                <td>$33,820,352.00</td>
                <td>$2,194,375.75</td>
              </tr>
              <tr>
                <td className="data-highlight">December 2021</td>
                <td>$22,406,180.00</td>
                <td>$3,456,830.75</td>
              </tr>
              <tr>
                <td className="data-highlight">January 2022</td>
                <td>$13,033,269.00</td>
                <td>$1,585,315.63</td>
              </tr>
              <tr>
                <td className="data-highlight">February 2022</td>
                <td>$11,106,930.00</td>
                <td>$1,102,242.88</td>
              </tr>
              <tr>
                <td className="data-highlight">April 2022</td>
                <td>$9,930,579.00</td>
                <td>$1,008,131.25</td>
              </tr>
              <tr>
                <td className="data-highlight">May 2022</td>
                <td>$9,261,275.00</td>
                <td>$2,194,375.75</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default SalesData;
